"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 16A8 8 0 118 0a8 8 0 010 16zm0-2A6 6 0 108 2a6 6 0 000 12zm1-2H7v-2h2v2zm0-3H7V4h2v5z"];
//# sourceMappingURL=issue.js.map